export default{
	setItemNum(state,data){
		state.loginData = data;
	},
	changeLogin(state,data){
		state.isLogin = 0;
	},
	setRed(state,data){
		state.isNew = data;
	}
}



// WEBPACK FOOTER //
// ./docs/store/mutations.js